import { useProfileStore } from '../../ModalProvider';

const fanaticsLiveWithCampaign =
  'https://www.fanatics.live/home?utm_source=fanatics_collect&utm_medium=onsite&utm_campaign=collect_navigation&utm_content=collect_cross_over';

export function generateFanaticsLiveLoginUrlWithCampaign() {
  return `https://www.fanatics.live/api/authn/login?callbackUrl=${encodeURIComponent(
    fanaticsLiveWithCampaign
  )}`;
}

export function useGetLiveLoginLink() {
  const { profile } = useProfileStore();
  const isDev =
    typeof window !== 'undefined' && window.location.hostname.includes('dev.');

  let url = profile
    ? generateFanaticsLiveLoginUrlWithCampaign()
    : fanaticsLiveWithCampaign;

  if (isDev) {
    url = url.replace(/www\.fanatics\.live/g, 'www.dev.fanatics.live');
  }

  return url;
}
